import store from "../../store/store";

export const componentKey = "PROVIDER_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setcloseEditTaskDialog: (state, action) => {
      state.closeEditTaskDialog = action.payload;
    },
    setproviderTaskListData: (state, action) => {
      state.taskListData = action.payload;
    },
    setUserProfileData: (state, action) => {
      state.userProfileData = action.payload;
    },
    setCloseAddUserProfileDialog: (state, action) => {
      state.closeAddUserProfileDialog = action.payload;
    },
    setDepartmentList: (state, action) => {
      state.departmentList = action.payload;
    },
    setCloseChangePasswordDialog: (state, action) => {
      state.closeChangePasswordDialog = action.payload;
    },
  },
  initialReducerState: {
    closeEditTaskDialog: false,
    providerTaskListData: {},
    userProfileData: {},
    closeAddUserProfileDialog: false,
    departmentList: {},
    closeChangePasswordDialog: false,
  },
});

export const {
  setcloseEditTaskDialog,
  setproviderTaskListData,
  setUserProfileData,
  setCloseAddUserProfileDialog,
  setDepartmentList,
  setCloseChangePasswordDialog,
} = actions;
